import PropTypes, { element, func } from "prop-types";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row, Input, InputGroup } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../../assets/scss/style.css";

import "flatpickr/dist/themes/material_blue.css";

import { withTranslation } from "react-i18next";

import { apiRoute } from "routes/apiRoutes";
// import { LoaderContext } from "context/ContextProvider"
import axios from "axios";
// import { toast } from "react-toastify"
import { alerShow, dateformat, dateTimeformat } from "admin/commonFunction";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import { getAllUser, updateUserDetail } from "services/userServices";
import { Form } from "react-bootstrap";
import { toastConfirm } from "common/toast";
import useApiStatus from "common/useApiStatus";
import Loader from "common/loader";
import TableContainer from "components/Common/TableContainer";
import NoRecordTable from "common/NoRecordTable";
import { fullDateFormat } from "common/utility";
import DateRangeFilter from "components/Common/DateRangeFilter";
const debounceTime = 400;
let distinctUntilChanged = null;
const AllUsers = (props) => {
  const { apiStatus, changeApiStatus } = useApiStatus();
  const [query, setQuery] = useState("");
  const [page, setPage] = useState({ current: 1, totalItems: 0, pageSize: 20 });
  const [listingData, setData] = useState([]);
  const [dateFilter, setDateFilter] = useState([]);
  const [status, setStatus] = useState("");
  const [calendarIsShowing, setCalendarIsShowing] = useState(false);
  const inputRef = useRef(null);

  //fetch users
  const fetchData = async (
    pageNumber = 1,
    pageSize = 20,
    search = "",
    dateFilter = [],
    isBlocked = "",
    exportRequest = "false"
  ) => {
    try {
      changeApiStatus(true, "");
      const [fromDate, toDate] = dateFilter || [];
      const responce = await getAllUser(
        pageNumber,
        pageSize,
        search,
        fromDate || "",
        toDate || "",
        isBlocked,
        exportRequest
      );
      if (exportRequest === "true") {
        changeApiStatus(false, "");
        return;
      }
      if (responce.status === 200) {
        setData(
          responce.data.items.map((val, index) => {
            return { ...val, serial: index + 1, copyNotification: false };
          })
        );

        setPage({
          ...page,
          totalItems: responce.data.totalItems,
          current: pageNumber,
        });
        changeApiStatus(false, "");
      }
    } catch (err) {
      changeApiStatus(false, "");
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData(page.current, page.pageSize);
  }, [page.current, page.pageSize]);

  const handleChange = (id, value) => {
    let data = {
      isBlocked: value.toString(),
      id: id,
    };
    toastConfirm(
      "Are you sure?",
      `${value === false ? " Sure Unfreeze" : "Sure Freeze"}`
    )
      .fire()
      .then(async (val) => {
        if (val.isConfirmed) {
          try {
            changeApiStatus(true, "");

            const response = await updateUserDetail(data);
            if (response.status === 200) {
              alerShow("success", response.message);

              changeApiStatus(false, "");
              fetchData(page.current, page.pageSize, query, dateFilter);
            } else {
              changeApiStatus(false, "");
              alerShow("error", updateResponse.error);
              throw new Error(updateResponse.error);
            }
          } catch (err) {
            changeApiStatus(false, "");
            alerShow("error", "errr");
          }
        }
      });
  };
  const onQueryChange = (e) => {
    const value = e.target.value.trim();
    setQuery(value);
    if (distinctUntilChanged) {
      clearTimeout(distinctUntilChanged);
      distinctUntilChanged = null;
    }
    if (value.length > 3) {
      distinctUntilChanged = setTimeout(() => {
        setQuery(value);
        console.log(value.length, "value");

        fetchData(1, page.pageSize, value, dateFilter);
        distinctUntilChanged = null;
      }, debounceTime);
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: "Sr. No",
        accessor: "serial",
        disableFilters: true,
        Cell: (cellProps) =>
          cellProps.value + (page.current - 1) * page.pageSize,
      },

      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        Cell: (cellProps) => cellProps.row.original?.name,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        Cell: (cellProps) =>
          cellProps.row.original?.email ? cellProps.row.original.email : "-",
      },
      {
        Header: "Phone Number",
        accessor: "phoneNumber",
        disableFilters: true,
        Cell: (cellProps) =>
          cellProps.row.original?.phoneNumber
            ? cellProps.row.original.phoneNumber
            : "-",
      },

      {
        Header: props.t("Date"),
        accessor: "createdAt",
        disableFilters: true,
        Cell: (cellProps) => fullDateFormat(cellProps.value),
      },
      {
        Header: "Block",
        accessor: "isBlocked",
        disableFilters: true,
        Cell: (cellProps) => (
          <Form.Check
            type="switch"
            onChange={(e) =>
              handleChange(cellProps.row.original._id, e.target.checked)
            }
            defaultChecked={cellProps.row.original.isBlocked}
          />
        ),
      },
    ],
    [page]
  );
  const changeStatus = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const statusVal = e.target.value;
    if (statusVal === status) {
      return;
    }
    setStatus(statusVal);
    fetchData(page.current, page.pageSize, query, dateFilter, statusVal, "");
  };
  const dateFilterChange = (e, picker) => {
    const filter = [
      picker.startDate.format("YYYY-MM-DD"),
      picker.endDate.format("YYYY-MM-DD"),
    ];
    setDateFilter(filter);
    fetchData(page.current, page.pageSize, query, filter, "");
  };
  const handleFilterChange = () => {
    fetchData(page.current, page.pageSize, query, dateFilter);
  };
  return apiStatus.inProgress ? (
    <Loader />
  ) : (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom py-2">
                  <Row>
                    <Col lg={6}>
                      <div className="search-box me-xxl-2  d-inline-block">
                        <div
                          className="position-relative"
                          style={{ marginTop: "10px" }}
                        >
                          <label
                            htmlFor="search-bar-0"
                            className="search-label"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <Input
                              id="search-bar-0"
                              className="form-control"
                              placeholder={`Search `}
                              onChange={onQueryChange}
                              value={query}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </Col>

                    <Col lg={2} xxl={3} className="">
                      <div className="">
                        <DateRangeFilter
                          dateFilterChange={dateFilterChange}
                          setCalendarIsShowing={setCalendarIsShowing}
                          inputRef={inputRef}
                          dateFilter={dateFilter}
                          setDateFilter={setDateFilter}
                          calendarIsShowing={calendarIsShowing}
                          handleFilterChange={handleFilterChange}
                        />
                      </div>
                    </Col>
                    <Col lg={2} xxl={3}>
                      <Input
                        type="select"
                        className="form-control"
                        onChange={(e) => changeStatus(e)}
                        value={status}
                      >
                        <option value="">{"All users"}</option>
                        <option value="true">{props.t("Blocked")}</option>
                      </Input>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody>
                  {apiStatus.inProgress ? (
                    <Loader />
                  ) : listingData?.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={listingData}
                      customPageSize={page.pageSize}
                      showPagination={true}
                      customPageSizeOptions={true}
                      customPage={page}
                      customSetPage={setPage}
                      className="custom-header-css"
                    />
                  ) : (
                    <NoRecordTable />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

AllUsers.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(AllUsers);
